/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
// Written by Forge Partner Development
//
// Permission to use, copy, modify, and distribute this software in
// object code form for any purpose and without fee is hereby granted,
// provided that the above copyright notice appears in all copies and
// that both that copyright notice and the limited warranty and
// restricted rights notice below appear in all supporting
// documentation.
//
// AUTODESK PROVIDES THIS PROGRAM "AS IS" AND WITH ALL FAULTS.
// AUTODESK SPECIFICALLY DISCLAIMS ANY IMPLIED WARRANTY OF
// MERCHANTABILITY OR FITNESS FOR A PARTICULAR USE.  AUTODESK, INC.
// DOES NOT WARRANT THAT THE OPERATION OF THE PROGRAM WILL BE
// UNINTERRUPTED OR ERROR FREE.
/////////////////////////////////////////////////////////////////////

var nodeProperties = {};
var leaves = [];
var i = 0;

app.dbIds = {};

// Model data

class ModelData {
  constructor(viewer) {
    // Node tree data
    this._treeData = {};

    // Map data
    this._mapData = {
      all: []
    };

    // Chart data
    this._chartData = {};

    // Calendar data
    this._calendarData = {};
  }

  init(callback) {
    var _this = this;
    var propertiesCategory = settings.propertiesCategory;
    var treeStructure = settings.treeStructure;
    var level1 = treeStructure[0];
    var level2 = treeStructure[1];
    var level3 = treeStructure[2];
    var level4 = treeStructure[3];

    // Init map data
    var map = settings.map;
    var mapValues = [];

    if (map && map.values && map.values.length) {
      $.each(map.values, function (index, item) {
        mapValues.push(item.value);
        _this._mapData[item.value] = [];
      });
    }

    // Calendar
    var calendar = settings.calendar;

    // Get db ids
    _this.getAllLeafComponents(function (dbIds) {
      // Count is needed to trigger callback
      var count = dbIds.length;

      // Loop through ids and set data accordingly
      dbIds.forEach(function (dbId) {
        viewer.getProperties(dbId, function (props) {
          // Cache element
          app.dbIds[dbId] = {};

          // Store data in variable
          var nodesItem = {
            id: dbId,
            tree: {},
            properties: []
          };

          // Loop through properties
          props.properties.forEach(function (prop) {
            // Force string as value
            prop.displayValue = prop.displayValue.toString(10);

            // Remove revit prefix
            prop.displayValue = prop.displayValue.replace('Revit ', '');

            // Skip categories that start with '<'
            if (prop.displayValue.indexOf('<') === 0) {
              return;
            }

            // Skip categories with value 'viewable_in'
            if (prop.displayName === 'viewable_in') {
              return;
            }




            // Chart data
            if (
              1==0
              //prop.displayCategory == 'Modelleigenschaften' &&
              //prop.displayName &&  //DMue20230316
              //prop.displayName && propertyName.indexOf('Chart') >= 0 &&
              //(prop.displayValue || parseInt(prop.displayValue) === 0)
            ) {
              if (!_this._chartData[prop.displayName]) {
                _this._chartData[prop.displayName] = {
                  ids: [],
                  limit: true,
                  children: {}
                };
              }
              _this._chartData[prop.displayName].ids.push(dbId);
              if (!_this._chartData[prop.displayName].children[prop.displayValue]) {
                _this._chartData[prop.displayName].children[prop.displayValue] = {
                  ids: [],
                  limit: true,
                  children: {}
                };
              }
              _this._chartData[prop.displayName].children[prop.displayValue].ids.push(dbId);
            }

            // Cache Data
            if (prop.displayName === 'GUID') {
              app.dbIds[dbId]['GUID'] = prop.displayValue;
            }
            if (prop.displayName === settings.guidProperty) {
              app.dbIds[dbId][settings.guidProperty] = prop.displayValue;
            }

            // Categorize map
            if (map && map.key && prop.displayName == map.key && mapValues.indexOf(prop.displayValue) > -1) {
              _this._mapData[prop.displayValue].push(dbId);
              _this._mapData['all'].push(dbId);
            }

            // Categorize calendar
            if (
              calendar.startProperty == prop.displayName ||
              calendar.endProperty == prop.displayName ||
              calendar.level1 == prop.displayName ||
              calendar.level2 == prop.displayName ||
              calendar.level3 == prop.displayName ||
              prop.displayCategory == settings.calendar.propertiesCategory
            ) {
              if (!_this._calendarData[dbId]) {
                _this._calendarData[dbId] = {};
              }
              nodesItem.properties.push(prop);
              _this._calendarData[dbId][prop.displayName] = prop.displayValue;
            }

            // Categorize node tree
            if (
              prop.displayName == level1 ||
              prop.displayName == level2 ||
              prop.displayName == level3 ||
              prop.displayName == level4
            ) {
              nodesItem.tree[prop.displayName] = prop.displayValue;
            }

            if (!propertiesCategory || prop.displayCategory == propertiesCategory) {
              nodesItem.properties.push(prop);
            }
          });

          if (nodesItem.properties.length) {
            nodeProperties[dbId] = nodesItem.properties;
          }

          var nameLevel1 = nodesItem.tree[level1];
          var nameLevel2 = nodesItem.tree[level2];
          var nameLevel3 = nodesItem.tree[level3];
          var nameLevel4 = nodesItem.tree[level4];

          if (nameLevel1 || nameLevel2 || nameLevel3 || nameLevel4) {
            if (nameLevel1 && !_this._treeData[nameLevel1]) {
              _this._treeData[nameLevel1] = {
                children: {},
                ids: []
              };
            }
            nameLevel1 && _this._treeData[nameLevel1].ids.push(nodesItem.id);

            if (nameLevel1 && nameLevel2 && !_this._treeData[nameLevel1].children[nameLevel2]) {
              _this._treeData[nameLevel1].children[nameLevel2] = {
                children: {},
                ids: []
              };
            }
            nameLevel1 && nameLevel2 && _this._treeData[nameLevel1].children[nameLevel2].ids.push(nodesItem.id);

            if (
              nameLevel1 &&
              nameLevel2 &&
              nameLevel3 &&
              !_this._treeData[nameLevel1].children[nameLevel2].children[nameLevel3]
            ) {
              _this._treeData[nameLevel1].children[nameLevel2].children[nameLevel3] = {
                children: {},
                ids: []
              };
            }
            nameLevel1 &&
              nameLevel2 &&
              nameLevel3 &&
              _this._treeData[nameLevel1].children[nameLevel2].children[nameLevel3].ids.push(nodesItem.id);

            if (
              nameLevel1 &&
              nameLevel2 &&
              nameLevel3 &&
              nameLevel4 &&
              !_this._treeData[nameLevel1].children[nameLevel2].children[nameLevel3].children[nameLevel4]
            ) {
              _this._treeData[nameLevel1].children[nameLevel2].children[nameLevel3].children[nameLevel4] = {
                children: {},
                ids: []
              };
            }
            nameLevel1 &&
              nameLevel2 &&
              nameLevel3 &&
              nameLevel4 &&
              _this._treeData[nameLevel1].children[nameLevel2].children[nameLevel3].children[nameLevel4].ids.push(
                nodesItem.id
              );
          }

          if (--count == 0) callback();
        });
      });
    });
  }

  // Get all node ids
  // https://learnforge.autodesk.io/#/viewer/extensions/panel?id=enumerate-leaf-nodes
  getAllLeafComponents(callback) {
    viewer.getObjectTree(function (tree) {
      tree.enumNodeChildren(
        tree.getRootId(),
        function (dbId) {
          if (tree.getChildCount(dbId) === 0) {
            leaves.push(dbId);
          }
        },
        true
      );
      callback(leaves);
    });
  }
}
